<ion-row class="c-border-bottom ion-margin-start">
  <ion-col size="12" class="ion-no-padding">
    <ion-row class="ion-margin-end">
      <ion-label *ngIf="!noLabelNoErrorMessage">{{ field.label }}</ion-label>
    </ion-row>
    <ion-row class="ion-margin-end">
      <ng-container *ngIf="cFormControl.disabled || disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId); else FieldNotDisabled">
        <ion-col size="12" class="ion-no-padding">
          <ion-item [button]="true" [detail]="false" [disabled]="true" [ngClass]="{'item-disabled': (field.readonly ?? 0) | readonlyByRule: etatId}">
            <ion-select class="gl-style-placeholder" justify="space-between" [formControl]="cFormControl" [placeholder]="field.placeholder" interface="popover">
              <ion-select-option [value]="option.value" *ngFor="let option of field.options | sortArrayByParameter:field.sort">{{ option.label }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ng-container>

      <ng-template #FieldNotDisabled>
        <ion-col size="12" class="ion-no-padding" [id]="selectTriggerId">
          <ion-item [button]="true" [detail]="false" [disabled]="true" class="gl-disable-invisible">
            <ion-select class="gl-style-placeholder" justify="space-between" 
            [formControl]="cFormControl" 
            [placeholder]="field.placeholder" 
            interface="popover"
            [disabled]="disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId)">
              <ion-select-option [value]="option.value" *ngFor="let option of field.options | sortArrayByParameter:field.sort">{{ option.label }}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ng-template>

    </ion-row>
    <ng-container *ngIf="!noLabelNoErrorMessage && cFormControl.errors && !disabledField && !((field.readonly ?? 0) | readonlyByRule: etatId)">
      <ng-container *ngIf="cFormControl.errors['err'] as err; else NothingSelected">
        <ng-container [ngTemplateOutlet]="StatusBanner" [ngTemplateOutletContext]="{data:err, class:'c-banner-error'}"></ng-container>
      </ng-container>
      <ng-template #NothingSelected>
        <ng-container *ngIf="cFormControl.dirty && cFormControl.errors['required']" [ngTemplateOutlet]="StatusBanner" [ngTemplateOutletContext]="{data:fieldNotFilled, class:'c-banner-error'}"></ng-container>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="cFormControl.valid && field.fieldValidDisplay" [ngTemplateOutlet]="StatusBanner" [ngTemplateOutletContext]="{data:field.fieldValidDisplay, class:'c-banner-valid'}"></ng-container>
  </ion-col>
</ion-row>

<ng-template #StatusBanner let-data='data' let-class="class">
  <ion-row class="ion-margin-end">
    <ion-col size="12" class="ion-no-padding">
      <div class="c-banner" [ngClass]="class">
        <fa-icon *ngIf="data.icon" [icon]="data.icon"></fa-icon>
        <ion-text>
          {{ data?.text }}
        </ion-text>
      </div>
    </ion-col>
  </ion-row>
</ng-template>

<ion-modal [trigger]="selectTriggerId" #modal>
  <ng-template>
    <app-c-typeahead
      class="ion-page"
      [title]="field.placeholder"
      [items]="field.options"
      [selectedItem]="cFormControl.value"
      (selectionChange)="optionSelectionChanged($event)"
      (selectionCancel)="dismissModal()"
    ></app-c-typeahead>
  </ng-template>
</ion-modal>